import { get_token } from "@/router";

import { client_domain } from "@/main.js";
import { get_retrieve_users_params } from "@/utils/organization_profile";
import { view_profile as view_profile_helper } from "@/views/Feed/feed_helper.js";
export default {
  data() {
    return ({
      users: [],
      token_exists: false,
      visibleUsersCount: 4,
      showAllUsers: false,
      visible_domain: false,
      following_profile_ids: {},
    });
  },

  computed: {
    filtered_users() {
      return this.showAllUsers
        ? this.users
        : this.users.slice(0, this.visibleUsersCount);
    },
  },

  mounted() {
    this.token_exists = get_token();

    if(client_domain.includes('tdm')||client_domain.includes('chamber') || client_domain.includes('cbo') || client_domain.includes('demo') || 
      client_domain.includes('engagenet') || client_domain.includes('bosa')){
        this.visible_domain = true;
      }
  
    if (this.token_exists) {
      this.fetchUsers();
    }
  },

  methods: {
    getToken() {
      return get_token();
    },
    shuffle_list(items) {
      return [...items].sort(() => Math.random() - 0.5);
    },
    get_user_avatar(user) {
      return user?.profile_picture || user?.profile_picture_url || '';
    },
    get_user_name(user) {
      return [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'Profile';
    },

    get_user_initials(user) {
      const name = this.get_user_name(user);
      return this.build_initials(name);
    },

    build_initials(name) {
      if (!name) return '';

      const parts = name.trim().split(' ');
      return this.get_first_two_initials(parts);
    },

    get_first_two_initials(parts) {
      let initials = '';

      for (let i = 0; i < Math.min(2, parts.length); i++) {
        const word = Reflect.get(parts, i);
        if (word) {
          initials += word[0].toUpperCase();
        }
      }

      return initials;
    },
    get_user_meta(user) {
      return user?.followed_by
        ? `Followed by ${user.followed_by}`
        : user?.is_following
          ? 'Followed by you'
          : 'Suggested for you';
    },
    is_followed_user(user) {
      return Boolean(user?.is_following || user?.is_followed || user?.followed);
    },
    get_follow_label(user) {
      return this.is_followed_user(user) ? 'Followed' : 'Follow';
    },
    set_user_profile_follow_state(user, profile_data) {
      const base_profile_id = profile_data?.base_profile?.id;
      if (base_profile_id) {
        user.base_profile_id = base_profile_id;
      }
      if (typeof profile_data?.is_following !== 'undefined') {
        user.is_following = profile_data.is_following;
      }
    },
    get_user_base_profile_id(user) {
      return user?.base_profile?.id || user?.base_profile_id || user?.profile?.base_profile?.id;
    },
    is_following_user(user) {
    const follow_key = this.get_user_base_profile_id(user) || `user-${user?.id}`;

    return Boolean(
      follow_key &&
      Reflect.get(
        this.following_profile_ids,
        String(follow_key)
      )
    );
  },
    follow_profile(user) {
      const base_profile_id = this.get_user_base_profile_id(user);
      if (this.is_following_user(user)) return;
      if (!base_profile_id) {
        this.submit_follow_profile(user, null);
        return;
      }

      this.submit_follow_profile(user, base_profile_id);
    },
    resolve_user_base_profile_id(user, callback) {
      const base_profile_id = this.get_user_base_profile_id(user);
      if (base_profile_id) {
        callback(base_profile_id);
        return;
      }

      if (!user?.id || this.is_following_user(user)) return;

      const follow_key = `user-${user.id}`;
      Reflect.set(
        this.following_profile_ids,
        String(follow_key),
        true
      );
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
        type: "GET",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: { user_id: user.id },
        success: (response) => {
          const profile_data = response?.data?.profile_data;
          const resolved_base_profile_id = profile_data?.base_profile?.id;
          if (response.status === "success" && resolved_base_profile_id) {
            this.set_user_profile_follow_state(user, profile_data);
            if (profile_data.is_following) return;
            callback(resolved_base_profile_id);
          }
        },
        error: (error) => {
          console.error("Error resolving profile:", error);
        },
        complete: () => {
            Reflect.set(
            this.following_profile_ids,
            String(follow_key),
            false
          );
        },
      });
    },
    submit_follow_profile(user, base_profile_id) {
      const follow_key = base_profile_id || `user-${user?.id}`;
      if (!follow_key) return;

      Reflect.set(
        this.following_profile_ids,
        String(follow_key),
        true
      );
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/follow_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(
          base_profile_id
            ? { target_base_profile_id: base_profile_id }
            : { target_user_id: user.id }
        ),
        success: (response) => {
          if (response.status === "success") {
            if (response.target_base_profile_id) {
              user.base_profile_id = response.target_base_profile_id;
            }
            user.is_following = response.is_following;
          }
        },
        error: (error) => {
          console.error("Error following profile:", error);
        },
        complete: () => {
             Reflect.set(
              this.following_profile_ids,
              String(follow_key),
              false
            );
        },
      });
    },

    fetchUsers() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
          type: "GET",
          headers: {
            Authorization: `Token ${get_token()}`,
            "Content-Type": "application/json",
          },
          data: get_retrieve_users_params(),
          success: (response) => {
            if (
              response.status === "success" &&
              response.data &&
              response.data.users_list
            ) {
              this.users = this.shuffle_list(response.data.users_list.map(user => ({
                ...user,
              })));
              this.hydrate_visible_user_follow_states();
            }
          },
          error: (error) => {
            console.error("Error fetching users:", error);
          },
        });
      },
      hydrate_visible_user_follow_states() {
        this.filtered_users.forEach((user) => {
          if (!user?.id || typeof user.is_following !== 'undefined') return;

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_profile/`,
            type: "GET",
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json",
            },
            data: { user_id: user.id },
            success: (response) => {
              const profile_data = response?.data?.profile_data;
              if (response.status === "success" && profile_data) {
                this.set_user_profile_follow_state(user, profile_data);
              }
            },
            error: (error) => {
              console.error("Error loading profile follow state:", error);
            },
          });
        });
      },

      view_profile(user){
        view_profile_helper(this.$router, user);
    }
  },
};
